module.exports = __webpack_public_path__ + "static/media/hut-poster.d71891e4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/hut-poster.jpeg
// module id = 182
// module chunks = 0